<script>
	import request from './request.vue';

	export default {
		getStats: async function () {
			const response = await request.send("stats", "getSummary", {}, true);
			return response.data;
		},
	}
</script>